<script setup>
import { CircleHelpIcon } from 'lucide-vue-next'
import { Popover, PopoverContent, PopoverTrigger, PopoverAnchor } from '@codinglabsau/gooey'
</script>

<template>
  <Popover>
    <PopoverAnchor>
      <PopoverTrigger class="flex items-center">
        <slot name="trigger">
          <CircleHelpIcon class="size-6 cursor-pointer text-gray-500" />
        </slot>
      </PopoverTrigger>
    </PopoverAnchor>
    <PopoverContent class="space-y-3 text-sm">
      <h4 class="font-medium leading-none">Claim a Convict</h4>
      <p class="text-sm text-muted-foreground">
        By claiming a convict, you'll have your name featured on their page. Feel free to make your
        claim for any reason – whether it's a familial connection or any other meaningful
        association.
      </p>
    </PopoverContent>
  </Popover>
</template>
